// What the Billing Type field shows in the event form.
//
// A matter whose client is the firm itself is never billable, so the answer is known
// as soon as the matter is picked, before a work type is chosen. Everything else
// takes the work type's own billing type, which is what the field always did.
//
// The server stores the same value (calendar/server/billStatus.js), so the field is
// not a display-only override. That distinction is what made the old
// isInternalClient override wrong: it hid billable internal registrations in the
// calendar while CRM kept storing them as Billable. See ZRM-ApS/mw issue 2 and 3.
export function billingTypeForMatter(matter, workType) {
  if (matter && matter.internal) return 'Non Billable';
  if (workType) return workType.billingtype || '';
  return '';
}
